import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

// --- Data for the Navbar (No changes here) ---
const navItems = [
    {
        title: 'About Us',
        children: [
            { title: 'Overview', path: '/about' },
            { title: 'Our Leadership & Governance', path: '/leadership' },
            { title: 'Institutional History', path: '/vision&mission' },
        ],
    },
    {
        title: 'Academics',
        children: [
            {
                title: 'Colleges and Courses',
                children: [
                    { title: 'Apex Institute of Technology (Engineering)', path: '/Apex-Institute-of-Technology-(Engineering)' },
                    { title: 'Apex College of Management and Computer Application', path: '/Apex-College-of-Management-and-Computer-Applications' },
                    { title: 'Apex College of Education', path: '/College-of-Education' },
                    { title: 'Apex College of Pharmacy', path: '/College-of-pharmacy' },
                ],
            },
            {
                title: 'Programs & Degrees',
                children: [
                    {
                        title: 'Undergraduate',
                        children: [
                            { title: 'Engineering (B.Tech.)', path: '/engineering' },
                            { title: 'BCA', path: '/bca' },
                            { title: 'BBA', path: '/management' },
                            { title: 'B.Com(Hons)', path: '/commerce' },
                            { title: 'B. Pharmacy', path: '/pharma' },
                            { title: 'D. Pharmacy', path: '/pharma' },
                            { title: 'B.Ed.', path: '/education' },
                            { title: 'BSc Home Sc.', path: '/education' },
                        ]
                    },
                    { title: 'Postgraduate', children: [{ title: 'MBA', path: '/programs/mba' }] },
                    {
                        title: 'Certificate & Diploma',
                        children: [
                            { title: 'Polytechnic/Diploma Engineering', path: '/programs/polytechnic' },
                            { title: 'PMKVY', path: '/programs/pmkvy' },
                            { title: 'Skill India', path: '/programs/skill-india' },
                        ]
                    },
                ],
            },
            {
                title: 'Research & Innovation',
                children: [
                    { title: 'International Conference-2025', path: '/research/conference-2025' },
                    { title: 'Incubation Centre', path: '/research/incubation' },
                ]
            },
            { title: 'Academic Calendar & Policies', path: '/academics/calendar-policies' },
        ],
    },
    { title: 'Admissions', path: 'https://admission.apex.ac.in' },
    { title: 'Gallery', path: '/gallery' },
    { title: 'Mandatory Disclosure', path: '/disclosure' },
    { title: 'Grievance', path: '/grievance' },
];


// --- Recursive MenuItem Component (No changes here) ---
const MenuItem = ({ item, depth, isMobile, openMenus, toggleMenu, closeAllMenus }) => {
    const hasChildren = item.children && item.children.length > 0;
    const isOpen = openMenus[item.title];
    
    const liRef = useRef(null);
    const [isFlipped, setIsFlipped] = useState(false);
    
    const hoverTimerRef = useRef(null);

    useLayoutEffect(() => {
        if (isOpen && !isMobile && hasChildren && liRef.current) {
            const dropdown = liRef.current.querySelector('.dropdown-menu');
            if (dropdown) {
                const rect = dropdown.getBoundingClientRect();
                if (rect.right > window.innerWidth) setIsFlipped(true);
                else setIsFlipped(false);
            }
        }
    }, [isOpen, isMobile, hasChildren]);

    const handleMouseEnter = () => {
        if (!isMobile) {
            clearTimeout(hoverTimerRef.current);
            toggleMenu(item.title, true);
        }
    };

    const handleMouseLeave = () => {
        if (!isMobile) {
            hoverTimerRef.current = setTimeout(() => {
                toggleMenu(item.title, false);
            }, 200);
        }
    };
    
    const handleToggleClick = (e) => {
        e.preventDefault();
        toggleMenu(item.title, !isOpen);
    };

    const handleLinkClick = () => {
        if (!hasChildren) closeAllMenus();
    };

    const itemClass = `menu-item depth-${depth} ${hasChildren ? 'has-children' : ''} ${isOpen ? 'is-open' : ''} ${isFlipped ? 'is-flipped' : ''}`;
    const linkClass = `nav-link depth-${depth}`;

    return (
        <li
            ref={liRef}
            className={itemClass}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            role="menuitem"
            aria-haspopup={hasChildren}
            aria-expanded={isOpen}
        >
            <Link to={item.path || '#'} className={linkClass} onClick={handleLinkClick}>
                {item.title}
                {hasChildren && !isMobile && <span className="desktop-arrow" />}
            </Link>
            
            {hasChildren && isMobile && (
                <button className="mobile-toggle" onClick={handleToggleClick}>
                    <span className="arrow" />
                </button>
            )}

            {hasChildren && (
                <ul className="dropdown-menu" role="menu">
                    {item.children.map((child, index) => (
                        <MenuItem
                            key={index}
                            item={child}
                            depth={depth + 1}
                            isMobile={isMobile}
                            openMenus={openMenus}
                            toggleMenu={toggleMenu}
                            closeAllMenus={closeAllMenus}
                        />
                    ))}
                </ul>
            )}
        </li>
    );
};

// --- Main Navbar Component (FIX APPLIED HERE) ---
const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 992);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 992;
            if (isMobileView !== mobile) {
                setIsMobileView(mobile);
                closeAllMenus();
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isMobileView]);

    useEffect(() => {
        document.body.classList.toggle('no-scroll', isMobileMenuOpen);
        return () => document.body.classList.remove('no-scroll');
    }, [isMobileMenuOpen]);

    const toggleMobileMenu = () => setIsMobileMenuOpen(prev => !prev);
    
    const closeAllMenus = () => {
        setIsMobileMenuOpen(false);
        setOpenDropdowns({});
    };

    const handleDropdownToggle = (title, shouldBeOpen) => {
        setOpenDropdowns(prev => ({
            // --- THIS IS THE FIX ---
            // Always spread the previous state. This allows multiple
            // dropdowns (parent and child) to be open simultaneously on desktop.
            ...prev,
            [title]: shouldBeOpen,
        }));
    };

    return (
        <>
            <nav className="navbar-component">
                <div className="navbar-container">
                    <Link to="/" className="navbar-brand" onClick={closeAllMenus}>
                        <img src="/img/apex_logo.png" alt="Apex Logo" className="navbar-logo" />
                        <div className="navbar-heading">
                            <h1 className="navbar-title">Apex Group of Institutions</h1>
                           <p className="topbar-subtitle">
                        B.TECH. | POLYTECHNIC | MBA | BBA | BCA | B.COM. (HONS.) | B.ED. | 
                        D.PHARM. | B.PHARM. | B.Sc.(PCM/Home Sc.)
                    </p>
                        </div>
                    </Link>

                    <button className={`menu-toggle ${isMobileMenuOpen ? 'is-open' : ''}`} onClick={toggleMobileMenu} aria-label="Toggle Menu" aria-expanded={isMobileMenuOpen}>
                        <span className="menu-bar" />
                        <span className="menu-bar" />
                        <span className="menu-bar" />
                    </button>

                    <ul className={`nav-menu ${isMobileMenuOpen ? 'is-open' : ''}`} role="menubar">
                        {navItems.map((item, index) => (
                            <MenuItem
                                key={index}
                                item={item}
                                depth={0}
                                isMobile={isMobileView}
                                openMenus={openDropdowns}
                                toggleMenu={handleDropdownToggle}
                                closeAllMenus={closeAllMenus}
                            />
                        ))}
                    </ul>
                </div>
            </nav>
            <div className={`navbar-overlay ${isMobileMenuOpen ? 'is-open' : ''}`} onClick={closeAllMenus} />
        </>
    );
};

export default Navbar;